<template>
    <div class="container">

        <template v-if="!loading && recipe">
					<snackbar-recipes/>
					<snackbar/>
      		<product-content class="ma-auto pa-5 pt-5" :item="recipe" :action="false" style='max-width: 1200px'/>
					<checkout-footer :recipesFooter="true"/>
        </template>

        <template v-if="loading">

           <loading-spin :height='300' v-if="loading"></loading-spin>

        </template>

    </div>

</template>

<script>
import { RecipeApi } from '../api/RecipeApi'
import RecipeContent from './RecipeContent'
import ProductContent from './Ecommerce/ProductContent'
import { Recipe } from '../core/Recipe'
import { Product } from '../core/Product'
import SnackbarRecipes from './Elements/SnackbarRecipes'
import Snackbar from './Elements/Snackbar'
import CheckoutFooter from './Checkout/CheckoutFooter'

export default {
	components: {
		'product-content': ProductContent,
		SnackbarRecipes,
		Snackbar,
		CheckoutFooter
	},

	data () {
		return {
			loading: true,
			recipeId: null,
			recipe: null
		}
	},
	watch: {
      '$route.params.id': {
          handler() {
              this.load()
          }
      }
  },
	methods: {
		load() {
			this.recipeId = this.$route.params.id
			var rm = new RecipeApi()
			rm.recipe(this.recipeId).then(response => {
				this.recipe = Product.createFromRecipe(response.body.data.resource)
				this.loading = false
			})/*.catch(response => {
				//this.$router.push({ name: 'cookbook' })
				})*/
		}
	},
		
	mounted () {
		this.load()
	}
}

</script>